import {CoreState} from '../reducers/core'

import {Action} from '../../../commons/src/types'
import {Provider} from '../types'

export type InitAction = Action<'CORE.INIT', void>
export type NoneAction = Action<'CORE.NONE', void>
export type FatalErrorAction = Action<'CORE.FATAL_ERROR', Error>
export type InitialDataReceivedAction = Action<'CORE.INITIAL_DATA_RECEIVED', Partial<CoreState>>
export type UpdateProviderAction = Action<'CORE.UPDATE_PROVIDER', Provider | null>

export type CoreAction =
  | NoneAction
  | InitAction
  | InitialDataReceivedAction
  | FatalErrorAction
  | UpdateProviderAction

// Special action where no reducer is reacting to
// but is sometimes necessary because success and fail action creators of redux-loop force you to return a valid action.
export const none = (): NoneAction => ({type: 'CORE.NONE', payload: undefined})

export const init = (): InitAction => ({
  type: 'CORE.INIT',
  payload: undefined,
})

export const initialDataReceived = (payload: Partial<CoreState>) => ({
  type: 'CORE.INITIAL_DATA_RECEIVED',
  payload,
})

export const fatalError = (error: Error): FatalErrorAction => ({
  type: 'CORE.FATAL_ERROR',
  payload: error,
})

export const updateProvider = (payload: Provider | null): UpdateProviderAction => ({
  type: 'CORE.UPDATE_PROVIDER',
  payload,
})
